import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {TabContent, TabPane, Nav, NavItem, NavLink, Row, Col} from 'reactstrap';
import QuantidadePercentualMOTsFaixaRemuneracaoStore from "../stores/QuantidadePercentualMOTsFaixaRemuneracaoStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {CustomBarChart} from "../../comum/components/CustomBarChart";
import {CustomPieChart} from "../../comum/components/CustomPieChart";
import classnames from 'classnames';

const FILTROS = ['AREA', 'CENTRAL', 'DIVISAO', 'DEPARTAMENTO', 'EMPRESA', 'COMPETENCIA_INICIO', 'COMPETENCIA_FIM'];

@inject("store")
@DataWrapper
@observer
export class QuantidadePercentualMOTsFaixaRemuneracao extends Component {
    constructor(props) {
        super(props);
        this.controller = new QuantidadePercentualMOTsFaixaRemuneracaoStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Quantidade e percentual de MOTs por faixa de remuneração");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                location={this.props.location}
                                controller={this.controller}
                                fields={FILTROS} />
                        { this.controller.dados && this.controller.dados.length > 0 &&
                            <div>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink onClick={() => { this.controller.toggle('1'); }}
                                            className={classnames({ active: this.controller.activeTab === '1' })} >
                                            Quantidade
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink onClick={() => { this.controller.toggle('2'); }}
                                            className={classnames({ active: this.controller.activeTab === '2' })} >
                                            Percentual
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={this.controller.activeTab}>
                                    <TabPane tabId="1">
                                        <Row>
                                            <Col xs={12} md={12} lg={10}>
                                                <CustomBarChart dataKeys={["Quantidade"]} data={this.controller.dados}
                                                        legend={false} labelAxisX={"Faixa de remuneração"} labelAxisY={"Quantidade"} />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Row>
                                            <Col xs={12} md={12} lg={10}>
                                                <CustomPieChart dataKey="Quantidade" data={this.controller.dados}
                                                        onClick={() => {}}/>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </div>
                        }
                        { this.controller.dados && this.controller.dados.length === 0 &&
                            <span>Nenhum resultado encontrado</span>
                        }
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
